import React, { useState, useEffect, useContext } from 'react'
import DoctorForm from "../doctor-form/DoctorForm"
import DoctorService from '../../../../../services/api/doctor.service'
import APIResponse from '../../../../templates/components/APIResponse'
import { store } from '../../../../../context/StateProvider'
import DimLoader from '../../../../templates/components/DimLoader'

const AddDoctor = (props) => {
    const { embed, inputChange, refresh } = props;
    const [formData, setFormData] = useState({ address: {} });
    const [messages, setMessages] = useState({})
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    const onSuccess = (message) => {
        dispatch({
            type: "setLocationProviderServices",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }


    const submitHandler = (data) => {
        if (data.firstName && data.lastName && data.phone && data.email) {
            data.phone = data.phone.includes("(") ? data.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "") : data.phone;
            data.npi = data.npi ? data.npi : ''
            data.doctorTypeTitle = data.doctorTypeCode ? data.doctorTypeCode : '';
            data.doctorTypeCode = data.doctorTypeCode ? data.doctorTypeCode : '';
            data.url = '';
            // return;
            setIsLoader(true)
            DoctorService.add(data)
                .then(response => {
                    setApiResponse(response)
                })
                .catch(error => {
                    setApiResponse(error)
                })
                .finally(() => {
                    setIsLoader(false)
                });
            }
    }

    const clearForm = () => {
        setFormData({})
    }
    return (
        <>
            {isLoader && <DimLoader />}
            <DoctorForm submitHandler={submitHandler} initialData={formData} onClose={() => { props.onClose() }} inputChange={inputChange} loaded={true} messages={messages} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default AddDoctor